import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  font-family: 'Outfit', 'Inter', sans-serif;
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3b82f6; /* Modern Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 20px;
`;

const Message = styled.p`
  color: #1e293b;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
`;

const PaymentResponsePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePaymentResponse = async () => {
      try {
        // Convert searchParams to a plain object
        const params: Record<string, string> = {};
        searchParams.forEach((value, key) => {
          params[key] = value;
        });

        const res = await axios.get(
          "https://api.report.erp.gouni.edu.ng/api/Payments/EtranzactCredoPaymentResponse",
          {
            params,
            headers: { accept: "*/*" },
          }
        );

        const redirectUrl = res.data?.link || res.data?.response;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          toast.error("No redirection link returned from the server.");
          navigate("/payment/payment-history");
        }
      } catch (err: any) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data ||
          err?.message ||
          "An error occurred while updating payment records.";
        toast.error(msg);
        navigate("/payment/payment-history");
      }
    };

    handlePaymentResponse();
  }, [searchParams, navigate]);

  return (
    <Container>
      <Spinner />
      <Message>updating payment records</Message>
    </Container>
  );
};

export default PaymentResponsePage;
